import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = no user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("te_admin_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("te_admin_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    // Step 1: returns a TOTP challenge (setup or verify). Never returns a JWT.
    const { data } = await api.post("/auth/login", { email, password });
    return data; // { step, challenge_token, qr_png_base64?, otpauth_uri?, secret? }
  };

  const verifyTotp = async (challenge_token, code) => {
    const { data } = await api.post("/auth/totp/verify", { challenge_token, code });
    localStorage.setItem("te_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("te_admin_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verifyTotp, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
